"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformCallbackResendRequest = exports.transformCallbackVerifierRequest = exports.transformCallbackRequest = exports.transformCallbackParsedResponse = exports.transformCallbackListResponse = exports.transformCallbackResponse = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const Error_1 = require("./Error");
const Date_1 = require("./Date");
function transformCallbackResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isEventErrorResponse)(status)) {
        return (0, Error_1.transformEventErrorResponse)(response);
    }
    const { callback } = response.response.result;
    return transformCallbackParsedResponse(callback);
}
exports.transformCallbackResponse = transformCallbackResponse;
function transformCallbackListResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isEventErrorResponse)(status)) {
        return (0, Error_1.transformEventErrorResponse)(response);
    }
    const { callbacks, per_page, total, page, pages } = response.response.result;
    return {
        callbacks: callbacks.map((callback) => transformCallbackParsedResponse(callback)),
        pages: {
            total,
            size: per_page,
            pages,
            page,
        },
    };
}
exports.transformCallbackListResponse = transformCallbackListResponse;
function transformCallbackParsedResponse(callback) {
    return {
        callbackId: callback.callbackid,
        uri: callback.uri,
        event: callback.event,
        verified: callback.verified,
        updatedAt: callback.updated_at && (0, Date_1.transformDateResponse)(callback.updated_at, Date_1.DateFormat['YYYY-MM-DD hh:mm:ss']),
    };
}
exports.transformCallbackParsedResponse = transformCallbackParsedResponse;
function transformCallbackRequest(callback) {
    const payload = {
        callback: {
            uri: callback.uri,
            event: callback.event,
        },
    };
    return JSON.stringify(payload);
}
exports.transformCallbackRequest = transformCallbackRequest;
function transformCallbackVerifierRequest(verifier) {
    const payload = {
        callback: {
            verifier: verifier,
        },
    };
    return JSON.stringify(payload);
}
exports.transformCallbackVerifierRequest = transformCallbackVerifierRequest;
function transformCallbackResendRequest() {
    const payload = {
        callback: {
            resend: true,
        },
    };
    return JSON.stringify(payload);
}
exports.transformCallbackResendRequest = transformCallbackResendRequest;
//# sourceMappingURL=Callback.js.map